











import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {executeQuery} from "@/data/repos/query"
import appConfig from "@/config"
import {defineComponent, reactive} from "@vue/composition-api"
import {datePeriodStartDate, formatDate} from "@/data/sources/dates"
import {differenceInDays} from "date-fns"
import {getParameterValue} from "@/data/sources/inputValues"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.TimeSeries(),
    widget: "Last30DaysActivity",
    title: "User activity",
    params: {
      datePeriod: {...WParamTpl.datePeriod(), _order: 1},
    },
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
        ...ChartDataTemplate(),
        xAxisName: "Date",
        yAxisName: "Page visits",
        showLabels: "1",
        animation: "0",
      },
  )
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    const chartDataConfig = getChartDataConfig()
    context.emit("config-update", config())
    const configChangeCallback = (config: any) => {
      if (config) {
        const now = new Date()
        const startDate = datePeriodStartDate(now, getParameterValue(config.params.datePeriod))
        const days = differenceInDays(now, startDate) + 1
        chartDataConfig.caption = "Period: " + formatDate(startDate) + " - " + formatDate(now)
        chartDataConfig.showLabels = days <= 90 ? "1" : "0"
      }
    }
    return {dataFetcher, chartDataConfig, dataplotClickCallback, configChangeCallback}
  },
})

async function dataFetcher(params: any): Promise<{ data: { value: string, label: string }[] } | null> {
  const now = new Date()
  const startDate = datePeriodStartDate(now, getParameterValue(params.datePeriod))
  const days = differenceInDays(now, startDate) + 1
  return {
    data: await executeQuery("idr", "lastNDaysActivity", {days: days}, filter) || [],
  }
}

function filter(data: any[]): { label: string, value: string }[] {
  return data.map((v) => {
        return {label: v.activityDate, value: v.loginCount}
      },
  )
}

function dataplotClickCallback(label: string, val: any) {
  const iprUrl = appConfig.IPR_BASE_URL
  window.open(iprUrl + `/pages/user_activity_log.asp?fromdate=${label}&todate=${label}`)
  console.log("chartClickCallback", label, val)
}
